module.exports = __webpack_public_path__ + "static/img/hongbao-red-dadan.2e14ac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/WZBankPC/hongbao-red-dadan.png
// module id = cC58
// module chunks = 70